import * as React from 'react';

import { H3 } from '../../../../designSystem/typography/Heading';
import { buildTranslator, StaticTextImportantCustomFormField } from '../../../../amorg-common';
import { CustomFormFieldCardColored } from '../../[parm]/_components/CustomFormFieldCard';

type StaticTextImportantCustomFormFieldComponentProps = {
    field:StaticTextImportantCustomFormField,
}
export function StaticTextImportantCustomFormFieldComponent(props:StaticTextImportantCustomFormFieldComponentProps):JSX.Element
{
    const translator = buildTranslator('da');

    return (
        <section>
            <CustomFormFieldCardColored variant='attention'>
                {props.field.header && <H3>{translator(props.field.header)}</H3>}
                <div dangerouslySetInnerHTML={{ __html: translator(props.field.text) }} />
            </CustomFormFieldCardColored>
        </section>
    );
}